import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const refresh = async () => {
    try {
      const response = await axios.get("/api/refresh", {
        withCredentials: true,
      });
      setAuth((prev) => {
        return {
          ...prev,
          userId: response.data.userId,
          username: response.data.user,
          email: response.data.email,
          avatar: response.data.avatar,
          roles: response.data.roles,
          accessToken: response.data.accessToken,
        };
      });
      return response.data.accessToken;
    } catch (e) {
      return null;
    }
  };

  return refresh;
};

export default useRefreshToken;
